import { TestCardBase } from "@app/provider/testData/testCard/TestCardBase";
import {
  ManagedBy,
  PrimaryAction,
  TestCard,
  TestCardStatus,
  TestType,
} from "@app/provider/testData/types";
import { IntlShape } from "react-intl/src/types";
import { messages } from "@app/provider/testData/messages";
import { Utils } from "@natera/material/lib/date";
import { getEstimatedResultsDeliveryDate } from "@app/utils";

export class OncologyTestCardBase extends TestCardBase {
  protected getDescriptionForSamplesReceived(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    return undefined;
  }

  protected getDescriptionForSampleReceived(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    if (testCard.sampleReceivedDate) {
      const estimatedResultsDeliveryDate = Utils.getUSLocaleDate(
        getEstimatedResultsDeliveryDate(
          testCard,
          new Date(testCard.sampleReceivedDate),
          testCard.isSignateraSubsequent
        )
      );
      return intl.formatMessage(messages.testCardDescSampleReceived, {
        estimatedResultsDate: estimatedResultsDeliveryDate,
      });
    }
    return intl.formatMessage(messages.testCardDescSample);
  }

  protected getDescriptionForResultReady(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    return intl.formatMessage(messages.testCardDescResultReadyReview);
  }

  protected getPrimaryActionForUpcomingTest(
    testCard: TestCard
  ): PrimaryAction | undefined {
    if (
      testCard.testType === TestType.LATITUDE &&
      testCard.managedBy === ManagedBy.NATERA
    ) {
      return PrimaryAction.SCHEDULE_A_DRAW;
    }

    if (
      testCard.testType === TestType.SIGNATERA &&
      testCard.managedBy === ManagedBy.NATERA
    ) {
      return PrimaryAction.SCHEDULE_A_DRAW;
    }
    return undefined;
  }

  protected getPrimaryActionForTestOrdered(
    testCard: TestCard
  ): PrimaryAction | undefined {
    if (testCard.testType === TestType.ALTERA) {
      return testCard.managedBy === ManagedBy.NATERA
        ? PrimaryAction.SCHEDULE_A_DRAW
        : undefined;
    }
    if (testCard.nextStatus === TestCardStatus.SAMPLE_RECEIVED) {
      return PrimaryAction.VIEW_TEST_DETAILS;
    }

    return undefined;
  }

  protected getPrimaryActionForKitShipped(
    testCard: TestCard
  ): PrimaryAction | undefined {
    return undefined;
  }
}
